// extracted by mini-css-extract-plugin
export var link = "_qg-0";